/**
 * Places the Express dispatch note (snippets/express-dispatch-option.liquid)
 * just below Buy now. The button sits inside the personalisation app's form,
 * rendered after this markup, so the note is moved into place - under the
 * quantity selector when that has already been moved there, so the preview
 * and Buy now stay together.
 */
if (!customElements.get('express-dispatch')) {
  customElements.define(
    'express-dispatch',
    class ExpressDispatch extends HTMLElement {
      connectedCallback() {
        // Moving the element re-runs connectedCallback; place it only once.
        if (this.dataset.placed === 'true') return;
        this.dataset.placed = 'true';

        const buttons = document.querySelector('.product-form__buttons');
        if (!buttons) return;
        const quantity = buttons.nextElementSibling;
        const anchor =
          quantity && quantity.classList.contains('product-form__quantity--inline') ? quantity : buttons;
        anchor.after(this);
      }
    }
  );
}
